import { Info } from 'lucide-react';
import { Card } from '../../../components/Card';

export function EmptyRecentPatientsList() {
  return (
    <Card className="flex h-40 w-full items-center justify-center" data-testid="empty-recent-patients-list">
      <div className="flex items-center gap-2">
        <Info className="h-4 w-4" />
        No patients to display. Try adjusting your date filter or come back after your first therapy session.
      </div>
    </Card>
  );
}
